import React, { useEffect, useState } from "react";
import ".//css/style.css";
import { useSelector } from "react-redux";
import { findDisplayName, findVesselNameById, findVisitorTypeById, isView, isViewOrgFeatures } from "../../../utils/commonFunctionsAndStatices";
import { CSOAPI } from "../../apis/apisServies";
import { selectNavigationPath, visitorID } from "../../Store/actions/profile/profileSelector";
import { selectToken } from "../../Store/actions/auth/authSelectors";
import { useNavigate } from "react-router-dom";
import { selectCSOData } from "../../Store/actions/csoReport/csoReportSelector";
const VisitorDetails = () => {
  const loginData = useSelector(selectToken);
  const visitor = useSelector(visitorID);
  const csoData = useSelector(selectCSOData);
  const path = useSelector(selectNavigationPath);
  const [visitordata, setVisitorData] = useState({});
  const [additionalFields, setAdditionalFields] = useState([]);
  const navigate = useNavigate();

  const getdata = async () => {
    const obj = {
      userid: loginData?.login_id,
      visitorid: visitor,
    };
    try {
      if (navigator.onLine) {
        const response = await CSOAPI(obj);
        const data = response?.data?.body;

        setVisitorData(data);
        setAdditionalFields(data?.items || []);
      }
    } catch (error) {
      console.error("Error during Visit Data:", error);
    }
  };
  const formatDateTime = (timestamp) => {
    if (timestamp === "null") {
      return "No date";
    } else {
      const date = new Date(timestamp);
      return date.toLocaleString();
    }
  };

  useEffect(() => {
    if (navigator.onLine) {
      getdata(); // Make API call if online
    } else {
      // Retrieve offline data from the Redux store
      const offlineData = csoData.find((item) => item.visitorid === visitor);
      if (offlineData && offlineData.items) {
        setVisitorData(offlineData);
        setAdditionalFields(offlineData.items);
      }
    }
  }, [visitor, csoData]);

  const cancelCheckout = () => {
      navigate(path);
  };

  return (
    <div className="container">
      <div className="card ps-lg-3 py-lg-3 p-md-3 p-3 p-lg-0 col-lg-12 col-md-12 col-sm-10 element-mobile">
        <div className="d-lg-flex gap-3 justify-content-center align-items-center align-items-lg-start ">
          {
            isViewOrgFeatures("isTakePicture") && (
              <div className="col-lg-3 col-md-10 col-sm-12 d-flex justify-content-start align-items-center pt-2  mb-md-2 ">
                {navigator.onLine && (
                  <img
                    src={visitordata?.Photo}
                    className="img-thumbnail rounded  d-block h-100 w-100"
                    alt="avatar_img"
                  />
                )}
                {!navigator.onLine && (
                  <img
                    id="offline"
                    className="img-thumbnail rounded d-block "
                    alt="offline image"
                  />
                )}
              </div>
            )
          }

          <div className={`${isViewOrgFeatures("isTakePicture") ? "col-lg-8 col-md-11 col-sm-12 gap-3" : "col-lg-11 col-md-11 col-sm-12 gap-3"}`}>
            <div className="visitor-Details-scroll">
              <div className="row px-2">
                <div className="col-md-6 col-sm-12 ">
                  <div className="rounded bg-light p-3  mt-2 mt-md-1 mt-lg-1 ">
                    <div className="d-flex align-items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="45"
                        height="45"
                        viewBox="0 0 45 45"
                        fill="none"
                      >
                        <path
                          d="M0.849609 6.11621C0.849609 2.8025 3.5359 0.116211 6.84961 0.116211H38.8496C42.1633 0.116211 44.8496 2.8025 44.8496 6.11621V38.1162C44.8496 41.4299 42.1633 44.1162 38.8496 44.1162H6.84961C3.5359 44.1162 0.849609 41.4299 0.849609 38.1162V6.11621Z"
                          fill="#0271BE"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M22.8496 13.1162C19.9501 13.1162 17.5996 15.4667 17.5996 18.3662C17.5996 21.2657 19.9501 23.6162 22.8496 23.6162C25.7491 23.6162 28.0996 21.2657 28.0996 18.3662C28.0996 15.4667 25.7491 13.1162 22.8496 13.1162ZM27.0713 24.261C28.905 22.9453 30.0996 20.7953 30.0996 18.3662C30.0996 14.3621 26.8537 11.1162 22.8496 11.1162C18.8455 11.1162 15.5996 14.3621 15.5996 18.3662C15.5996 20.7953 16.7942 22.9453 18.6279 24.261C17.3402 24.6725 16.171 25.2685 15.1785 26.0129C13.1795 27.5122 11.8496 29.6598 11.8496 32.1162C11.8496 32.6685 12.2973 33.1162 12.8496 33.1162C13.4019 33.1162 13.8496 32.6685 13.8496 32.1162C13.8496 30.4305 14.7583 28.8281 16.3785 27.6129C17.9991 26.3975 20.2836 25.6162 22.8496 25.6162C25.4156 25.6162 27.7002 26.3975 29.3207 27.6129C30.9409 28.8281 31.8496 30.4305 31.8496 32.1162C31.8496 32.6685 32.2973 33.1162 32.8496 33.1162C33.4019 33.1162 33.8496 32.6685 33.8496 32.1162C33.8496 29.6598 32.5197 27.5122 30.5207 26.0129C29.5282 25.2685 28.359 24.6725 27.0713 24.261Z"
                          fill="white"
                        />
                      </svg>
                      <div className="d-flex flex-column ms-2">
                        <label className="text-secondary">
                          {findDisplayName(
                            "visitorLogDetailsFirstNameLabel",
                            "First Name"
                          )}
                        </label>
                        <strong className="text-dark font-weight-bold">
                          {visitordata?.firstname}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-12 ">
                  <div className="rounded bg-light p-3  mt-2 mt-md-1 mt-lg-1 ">
                    <div className="d-flex align-items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="45"
                        height="45"
                        viewBox="0 0 45 45"
                        fill="none"
                      >
                        <path
                          d="M0.849609 6.11621C0.849609 2.8025 3.5359 0.116211 6.84961 0.116211H38.8496C42.1633 0.116211 44.8496 2.8025 44.8496 6.11621V38.1162C44.8496 41.4299 42.1633 44.1162 38.8496 44.1162H6.84961C3.5359 44.1162 0.849609 41.4299 0.849609 38.1162V6.11621Z"
                          fill="#0271BE"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M22.8496 13.1162C19.9501 13.1162 17.5996 15.4667 17.5996 18.3662C17.5996 21.2657 19.9501 23.6162 22.8496 23.6162C25.7491 23.6162 28.0996 21.2657 28.0996 18.3662C28.0996 15.4667 25.7491 13.1162 22.8496 13.1162ZM27.0713 24.261C28.905 22.9453 30.0996 20.7953 30.0996 18.3662C30.0996 14.3621 26.8537 11.1162 22.8496 11.1162C18.8455 11.1162 15.5996 14.3621 15.5996 18.3662C15.5996 20.7953 16.7942 22.9453 18.6279 24.261C17.3402 24.6725 16.171 25.2685 15.1785 26.0129C13.1795 27.5122 11.8496 29.6598 11.8496 32.1162C11.8496 32.6685 12.2973 33.1162 12.8496 33.1162C13.4019 33.1162 13.8496 32.6685 13.8496 32.1162C13.8496 30.4305 14.7583 28.8281 16.3785 27.6129C17.9991 26.3975 20.2836 25.6162 22.8496 25.6162C25.4156 25.6162 27.7002 26.3975 29.3207 27.6129C30.9409 28.8281 31.8496 30.4305 31.8496 32.1162C31.8496 32.6685 32.2973 33.1162 32.8496 33.1162C33.4019 33.1162 33.8496 32.6685 33.8496 32.1162C33.8496 29.6598 32.5197 27.5122 30.5207 26.0129C29.5282 25.2685 28.359 24.6725 27.0713 24.261Z"
                          fill="white"
                        />
                      </svg>
                      <div className="d-flex flex-column ms-2">
                        <label className="text-secondary">
                          {findDisplayName(
                            "visitorLogDetailsLastNameLabel",
                            "Last Name"
                          )}
                        </label>
                        <strong className="text-dark font-weight-bold">
                          {visitordata?.lastname}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div className="row mt-2 px-2">
                {
                  isViewOrgFeatures("isVisibleBatch") && (
                    <div className="col-md-6 col-sm-12 mt-2 mt-lg-0 mt-md-0">
                      <div className="rounded bg-light p-3 mt-2 mt-md-1 mt-lg-1 ">
                        <div className="d-flex align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="45"
                            height="45"
                            viewBox="0 0 45 45"
                            fill="none"
                          >
                            <path
                              d="M0.6604 6.11621C0.6604 2.8025 3.34669 0.116211 6.6604 0.116211H38.6604C41.9741 0.116211 44.6604 2.8025 44.6604 6.11621V38.1162C44.6604 41.4299 41.9741 44.1162 38.6604 44.1162H6.6604C3.34669 44.1162 0.6604 41.4299 0.6604 38.1162V6.11621Z"
                              fill="#0271BE"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12.1604 15.6162C12.1604 13.9594 13.5035 12.6162 15.1604 12.6162H31.1604C32.8173 12.6162 34.1604 13.9594 34.1604 15.6162V27.6162C34.1604 29.2731 32.8173 30.6162 31.1604 30.6162H23.1604C22.6081 30.6162 22.1604 30.1685 22.1604 29.6162C22.1604 29.0639 22.6081 28.6162 23.1604 28.6162H31.1604C31.7127 28.6162 32.1604 28.1685 32.1604 27.6162V15.6162C32.1604 15.0639 31.7127 14.6162 31.1604 14.6162H15.1604C14.6081 14.6162 14.1604 15.0639 14.1604 15.6162V19.6162C14.1604 20.1685 13.7127 20.6162 13.1604 20.6162C12.6081 20.6162 12.1604 20.1685 12.1604 19.6162V15.6162ZM21.1604 16.6162C21.7127 16.6162 22.1604 17.0639 22.1604 17.6162V21.6162C22.1604 22.1685 21.7127 22.6162 21.1604 22.6162C20.6081 22.6162 20.1604 22.1685 20.1604 21.6162V17.6162C20.1604 17.0639 20.6081 16.6162 21.1604 16.6162ZM25.1604 16.6162C25.7127 16.6162 26.1604 17.0639 26.1604 17.6162V25.6162C26.1604 26.1685 25.7127 26.6162 25.1604 26.6162C24.6081 26.6162 24.1604 26.1685 24.1604 25.6162V17.6162C24.1604 17.0639 24.6081 16.6162 25.1604 16.6162ZM29.1604 18.6162C29.7127 18.6162 30.1604 19.0639 30.1604 19.6162V25.6162C30.1604 26.1685 29.7127 26.6162 29.1604 26.6162C28.6081 26.6162 28.1604 26.1685 28.1604 25.6162V19.6162C28.1604 19.0639 28.6081 18.6162 29.1604 18.6162ZM16.1604 23.6162C15.6081 23.6162 15.1604 24.0639 15.1604 24.6162C15.1604 25.1685 15.6081 25.6162 16.1604 25.6162C16.7127 25.6162 17.1604 25.1685 17.1604 24.6162C17.1604 24.0639 16.7127 23.6162 16.1604 23.6162ZM18.6555 26.2824C18.9744 25.8058 19.1604 25.2327 19.1604 24.6162C19.1604 22.9594 17.8173 21.6162 16.1604 21.6162C14.5035 21.6162 13.1604 22.9594 13.1604 24.6162C13.1604 25.2327 13.3464 25.8058 13.6653 26.2824C12.1692 27.1453 11.1604 28.76 11.1604 30.6111C11.1604 31.1662 11.6104 31.6162 12.1655 31.6162H20.1553C20.7104 31.6162 21.1604 31.1662 21.1604 30.6111C21.1604 28.76 20.1516 27.1453 18.6555 26.2824ZM16.1604 27.6162C14.8541 27.6162 13.7416 28.452 13.3302 29.6162H18.9906C18.5792 28.452 17.4667 27.6162 16.1604 27.6162Z"
                              fill="white"
                            />
                          </svg>
                          <div className="d-flex flex-column ms-2">
                            <label className="text-secondary">
                              {findDisplayName(
                                "visitorLogDetailsBadgeNumberLabel",
                                "Badge Number"
                              )}
                            </label>
                            <strong className="text-dark font-weight-bold">
                              {visitordata?.Badge}
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                <div className="col-md-6 col-sm-12 ">
                  <div className="rounded bg-light p-3  mt-2 mt-md-1 mt-lg-1 ">
                    <div className="d-flex align-items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="45"
                        height="45"
                        viewBox="0 0 45 45"
                        fill="none"
                      >
                        <path
                          d="M0.849609 6.11621C0.849609 2.8025 3.5359 0.116211 6.84961 0.116211H38.8496C42.1633 0.116211 44.8496 2.8025 44.8496 6.11621V38.1162C44.8496 41.4299 42.1633 44.1162 38.8496 44.1162H6.84961C3.5359 44.1162 0.849609 41.4299 0.849609 38.1162V6.11621Z"
                          fill="#0271BE"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M19.8059 10.1162H25.8934C27.2564 10.1162 28.3404 10.1162 29.215 10.1877C30.1106 10.2608 30.8743 10.4139 31.5736 10.7702C32.7025 11.3454 33.6204 12.2633 34.1956 13.3923C34.5519 14.0915 34.705 14.8552 34.7782 15.7508C34.8496 16.6254 34.8496 17.7094 34.8496 19.0724V25.16C34.8496 26.523 34.8496 27.607 34.7782 28.4816C34.705 29.3772 34.5519 30.1409 34.1956 30.8402C33.6204 31.9691 32.7025 32.887 31.5736 33.4622C30.8743 33.8185 30.1106 33.9716 29.215 34.0448C28.3404 34.1162 27.2564 34.1162 25.8934 34.1162H19.8058C18.4428 34.1162 17.3588 34.1162 16.4842 34.0448C15.5886 33.9716 14.8249 33.8185 14.1257 33.4622C12.9967 32.887 12.0788 31.9691 11.5036 30.8402C11.1473 30.1409 10.9942 29.3772 10.9211 28.4816C10.8496 27.607 10.8496 26.523 10.8496 25.16V19.0725C10.8496 17.7094 10.8496 16.6254 10.9211 15.7508C10.9942 14.8552 11.1473 14.0915 11.5036 13.3923C12.0788 12.2633 12.9967 11.3454 14.1257 10.7702C14.8249 10.4139 15.5886 10.2608 16.4842 10.1877C17.3588 10.1162 18.4428 10.1162 19.8059 10.1162ZM16.6471 12.181C15.8751 12.2441 15.404 12.3635 15.0336 12.5522C14.281 12.9357 13.6691 13.5476 13.2856 14.3002C13.0969 14.6706 12.9775 15.1417 12.9144 15.9137C12.8504 16.6972 12.8496 17.6996 12.8496 19.1162V25.1162C12.8496 26.5328 12.8504 27.5352 12.9144 28.3188C12.9775 29.0907 13.0969 29.5619 13.2856 29.9322C13.6691 30.6848 14.281 31.2967 15.0336 31.6802C15.404 31.8689 15.8751 31.9883 16.6471 32.0514C17.4306 32.1154 18.433 32.1162 19.8496 32.1162H25.8496C27.2662 32.1162 28.2686 32.1154 29.0522 32.0514C29.8241 31.9883 30.2953 31.8689 30.6656 31.6802C31.4182 31.2967 32.0301 30.6848 32.4136 29.9322C32.6023 29.5619 32.7217 29.0907 32.7848 28.3188C32.8488 27.5352 32.8496 26.5328 32.8496 25.1162V19.1162C32.8496 17.6996 32.8488 16.6972 32.7848 15.9137C32.7217 15.1417 32.6023 14.6706 32.4136 14.3002C32.0301 13.5476 31.4182 12.9357 30.6656 12.5522C30.2953 12.3635 29.8241 12.2441 29.0522 12.181C28.2686 12.117 27.2662 12.1162 25.8496 12.1162H19.8496C18.433 12.1162 17.4306 12.117 16.6471 12.181ZM17.8496 16.1162C17.8496 15.5639 18.2973 15.1162 18.8496 15.1162H26.8496C27.4019 15.1162 27.8496 15.5639 27.8496 16.1162C27.8496 16.6685 27.4019 17.1162 26.8496 17.1162H23.8496V24.1162C23.8496 24.6685 23.4019 25.1162 22.8496 25.1162C22.2973 25.1162 21.8496 24.6685 21.8496 24.1162V17.1162H18.8496C18.2973 17.1162 17.8496 16.6685 17.8496 16.1162ZM17.8496 28.1162C17.8496 27.5639 18.2973 27.1162 18.8496 27.1162H26.8496C27.4019 27.1162 27.8496 27.5639 27.8496 28.1162C27.8496 28.6685 27.4019 29.1162 26.8496 29.1162H18.8496C18.2973 29.1162 17.8496 28.6685 17.8496 28.1162Z"
                          fill="white"
                        />
                      </svg>
                      <div className="d-flex flex-column ms-2">
                        <label className="text-secondary">
                          {findDisplayName(
                            "visitorLogDetailsVesselLabel",
                            "Vessel"
                          )}
                        </label>
                        <strong className="text-dark font-weight-bold">
                          {findVesselNameById(visitordata?.Locationid)}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
              <div className="row px-2 mt-2">
                <div className="col-md-6 col-sm-12 ">
                  <div className="rounded bg-light p-3  mt-2 mt-md-1 mt-lg-1 ">
                    <div className="d-flex align-items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="45"
                        height="45"
                        viewBox="0 0 45 45"
                        fill="none"
                      >
                        <path
                          d="M0.849609 6.11621C0.849609 2.8025 3.5359 0.116211 6.84961 0.116211H38.8496C42.1633 0.116211 44.8496 2.8025 44.8496 6.11621V38.1162C44.8496 41.4299 42.1633 44.1162 38.8496 44.1162H6.84961C3.5359 44.1162 0.849609 41.4299 0.849609 38.1162V6.11621Z"
                          fill="#0271BE"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M19.8059 10.1162H25.8934C27.2564 10.1162 28.3404 10.1162 29.215 10.1877C30.1106 10.2608 30.8743 10.4139 31.5736 10.7702C32.7025 11.3454 33.6204 12.2633 34.1956 13.3923C34.5519 14.0915 34.705 14.8552 34.7782 15.7508C34.8496 16.6254 34.8496 17.7094 34.8496 19.0724V25.16C34.8496 26.523 34.8496 27.607 34.7782 28.4816C34.705 29.3772 34.5519 30.1409 34.1956 30.8402C33.6204 31.9691 32.7025 32.887 31.5736 33.4622C30.8743 33.8185 30.1106 33.9716 29.215 34.0448C28.3404 34.1162 27.2564 34.1162 25.8934 34.1162H19.8058C18.4428 34.1162 17.3588 34.1162 16.4842 34.0448C15.5886 33.9716 14.8249 33.8185 14.1257 33.4622C12.9967 32.887 12.0788 31.9691 11.5036 30.8402C11.1473 30.1409 10.9942 29.3772 10.9211 28.4816C10.8496 27.607 10.8496 26.523 10.8496 25.16V19.0725C10.8496 17.7094 10.8496 16.6254 10.9211 15.7508C10.9942 14.8552 11.1473 14.0915 11.5036 13.3923C12.0788 12.2633 12.9967 11.3454 14.1257 10.7702C14.8249 10.4139 15.5886 10.2608 16.4842 10.1877C17.3588 10.1162 18.4428 10.1162 19.8059 10.1162ZM16.6471 12.181C15.8751 12.2441 15.404 12.3635 15.0336 12.5522C14.281 12.9357 13.6691 13.5476 13.2856 14.3002C13.0969 14.6706 12.9775 15.1417 12.9144 15.9137C12.8504 16.6972 12.8496 17.6996 12.8496 19.1162V25.1162C12.8496 26.5328 12.8504 27.5352 12.9144 28.3188C12.9775 29.0907 13.0969 29.5619 13.2856 29.9322C13.6691 30.6848 14.281 31.2967 15.0336 31.6802C15.404 31.8689 15.8751 31.9883 16.6471 32.0514C17.4306 32.1154 18.433 32.1162 19.8496 32.1162H25.8496C27.2662 32.1162 28.2686 32.1154 29.0522 32.0514C29.8241 31.9883 30.2953 31.8689 30.6656 31.6802C31.4182 31.2967 32.0301 30.6848 32.4136 29.9322C32.6023 29.5619 32.7217 29.0907 32.7848 28.3188C32.8488 27.5352 32.8496 26.5328 32.8496 25.1162V19.1162C32.8496 17.6996 32.8488 16.6972 32.7848 15.9137C32.7217 15.1417 32.6023 14.6706 32.4136 14.3002C32.0301 13.5476 31.4182 12.9357 30.6656 12.5522C30.2953 12.3635 29.8241 12.2441 29.0522 12.181C28.2686 12.117 27.2662 12.1162 25.8496 12.1162H19.8496C18.433 12.1162 17.4306 12.117 16.6471 12.181ZM17.8496 16.1162C17.8496 15.5639 18.2973 15.1162 18.8496 15.1162H26.8496C27.4019 15.1162 27.8496 15.5639 27.8496 16.1162C27.8496 16.6685 27.4019 17.1162 26.8496 17.1162H23.8496V24.1162C23.8496 24.6685 23.4019 25.1162 22.8496 25.1162C22.2973 25.1162 21.8496 24.6685 21.8496 24.1162V17.1162H18.8496C18.2973 17.1162 17.8496 16.6685 17.8496 16.1162ZM17.8496 28.1162C17.8496 27.5639 18.2973 27.1162 18.8496 27.1162H26.8496C27.4019 27.1162 27.8496 27.5639 27.8496 28.1162C27.8496 28.6685 27.4019 29.1162 26.8496 29.1162H18.8496C18.2973 29.1162 17.8496 28.6685 17.8496 28.1162Z"
                          fill="white"
                        />
                      </svg>
                      <div className="d-flex flex-column ms-2">
                        <label className="text-secondary">
                          {findDisplayName(
                            "visitorLogDetailsVisitorTypeLabel",
                            "Visitor Type"
                          )}
                        </label>
                        <strong className="text-dark font-weight-bold">
                          {findVisitorTypeById(visitordata?.visitortypeid)}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>

                {visitordata &&
                  visitordata.items &&
                  visitordata.items.length > 0 &&
                  visitordata.items.map((item, index) => (
                    <div className="col-md-6 mt-sm-1" key={index}>
                      <div className="rounded bg-light p-3 mt-2 mb-2 mt-md-0 mt-lg-0">
                        <div className="d-flex align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="45"
                            height="45"
                            viewBox="0 0 45 45"
                            fill="none"
                          >
                            <path
                              d="M0.849609 6.11621C0.849609 2.8025 3.5359 0.116211 6.84961 0.116211H38.8496C42.1633 0.116211 44.8496 2.8025 44.8496 6.11621V38.1162C44.8496 41.4299 42.1633 44.1162 38.8496 44.1162H6.84961C3.5359 44.1162 0.849609 41.4299 0.849609 38.1162V6.11621Z"
                              fill="#0271BE"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M19.8059 10.1162H25.8934C27.2564 10.1162 28.3404 10.1162 29.215 10.1877C30.1106 10.2608 30.8743 10.4139 31.5736 10.7702C32.7025 11.3454 33.6204 12.2633 34.1956 13.3923C34.5519 14.0915 34.705 14.8552 34.7782 15.7508C34.8496 16.6254 34.8496 17.7094 34.8496 19.0724V25.16C34.8496 26.523 34.8496 27.607 34.7782 28.4816C34.705 29.3772 34.5519 30.1409 34.1956 30.8402C33.6204 31.9691 32.7025 32.887 31.5736 33.4622C30.8743 33.8185 30.1106 33.9716 29.215 34.0448C28.3404 34.1162 27.2564 34.1162 25.8934 34.1162H19.8058C18.4428 34.1162 17.3588 34.1162 16.4842 34.0448C15.5886 33.9716 14.8249 33.8185 14.1257 33.4622C12.9967 32.887 12.0788 31.9691 11.5036 30.8402C11.1473 30.1409 10.9942 29.3772 10.9211 28.4816C10.8496 27.607 10.8496 26.523 10.8496 25.16V19.0725C10.8496 17.7094 10.8496 16.6254 10.9211 15.7508C10.9942 14.8552 11.1473 14.0915 11.5036 13.3923C12.0788 12.2633 12.9967 11.3454 14.1257 10.7702C14.8249 10.4139 15.5886 10.2608 16.4842 10.1877C17.3588 10.1162 18.4428 10.1162 19.8059 10.1162ZM16.6471 12.181C15.8751 12.2441 15.404 12.3635 15.0336 12.5522C14.281 12.9357 13.6691 13.5476 13.2856 14.3002C13.0969 14.6706 12.9775 15.1417 12.9144 15.9137C12.8504 16.6972 12.8496 17.6996 12.8496 19.1162V25.1162C12.8496 26.5328 12.8504 27.5352 12.9144 28.3188C12.9775 29.0907 13.0969 29.5619 13.2856 29.9322C13.6691 30.6848 14.281 31.2967 15.0336 31.6802C15.404 31.8689 15.8751 31.9883 16.6471 32.0514C17.4306 32.1154 18.433 32.1162 19.8496 32.1162H25.8496C27.2662 32.1162 28.2686 32.1154 29.0522 32.0514C29.8241 31.9883 30.2953 31.8689 30.6656 31.6802C31.4182 31.2967 32.0301 30.6848 32.4136 29.9322C32.6023 29.5619 32.7217 29.0907 32.7848 28.3188C32.8488 27.5352 32.8496 26.5328 32.8496 25.1162V19.1162C32.8496 17.6996 32.8488 16.6972 32.7848 15.9137C32.7217 15.1417 32.6023 14.6706 32.4136 14.3002C32.0301 13.5476 31.4182 12.9357 30.6656 12.5522C30.2953 12.3635 29.8241 12.2441 29.0522 12.181C28.2686 12.117 27.2662 12.1162 25.8496 12.1162H19.8496C18.433 12.1162 17.4306 12.117 16.6471 12.181ZM17.8496 16.1162C17.8496 15.5639 18.2973 15.1162 18.8496 15.1162H26.8496C27.4019 15.1162 27.8496 15.5639 27.8496 16.1162C27.8496 16.6685 27.4019 17.1162 26.8496 17.1162H23.8496V24.1162C23.8496 24.6685 23.4019 25.1162 22.8496 25.1162C22.2973 25.1162 21.8496 24.6685 21.8496 24.1162V17.1162H18.8496C18.2973 17.1162 17.8496 16.6685 17.8496 16.1162ZM17.8496 28.1162C17.8496 27.5639 18.2973 27.1162 18.8496 27.1162H26.8496C27.4019 27.1162 27.8496 27.5639 27.8496 28.1162C27.8496 28.6685 27.4019 29.1162 26.8496 29.1162H18.8496C18.2973 29.1162 17.8496 28.6685 17.8496 28.1162Z"
                              fill="white"
                            />
                          </svg>
                          <div className="d-flex flex-column ms-2">
                            <label className="text-secondary d-flex justify-content-start">
                              {item.field_name}
                            </label>
                            <strong className="">
                              {item.field_result === "true"
                                ? "Yes"
                                : item.field_result === "false"
                                  ? "No"
                                  : item.field_result === "" ? "None" : item.field_result.charAt(0).toUpperCase() +
                                    item.field_result.slice(1)}{" "}
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>


            <div className=" col-11 d-flex justify-content-end mt-2 ">
              <button
                className=" btn btn-secondary"
                onClick={() => cancelCheckout()}
              >
                {findDisplayName("visitorLogDetailsCancelButton", "Cancel")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisitorDetails;
